import { SelectorBase } from "../../Config/SelectorBase";
import { IPortalLoadingState } from './PortalLoadingState';


/* Selector represents the data 
 * that needs to be displayed no update or delete should here
 * All of the updates and delete (data changes) should 
 * be done via action in the reducer
 */
export class PortalLoadingStateSelector extends SelectorBase {
    public static getLoadingState(): IPortalLoadingState{
        const session = super.getDataSource();
        const loadingState : IPortalLoadingState = session.PortalLoadingState.withId("0");
        return loadingState;
    }
}


// WEBPACK FOOTER //
// ./src/Entities/PortalLoadingState/PortalLoadingState.Selector.ts